import "./language-tabs.css";

import { wrapRootElement as wrap } from "./wrap-root-element";

export const wrapRootElement = wrap;
export const onServiceWorkerUpdateReady = () => {
    const answer = window.confirm(
      `You know what? Dev Journal has been updated recently. ` +
        `Wanna reload to display the latest content?`
    )
  
    if (answer === true) {
      //window.location.reload(true)
      window.location.replace(window.location.href)
    }
  }